<template>
  <div v-if="isCallActive" >
    <div v-if="!transferringCall" class="transfer-call__content">
      <header>
        <div>
          <h3>{{ $t('agent-console.transfer-call.title') }}</h3>
          <el-button type="text" @click="() => {goBackByUser = true; handleGoBack()}">
            <i class="fas fa-times"></i>
          </el-button >
        </div>
        <p>{{ $t('agent-console.transfer-call.select-where-you-want-to-transfer-the-call-to') }}</p>
      </header>
      <el-radio-group v-model="filter">
        <el-radio-button v-for="type in ['agent', 'queue', 'custom']" :label="type" :key="type">
          {{ $t(`agent-console.transfer-call.${type}`) }}
        </el-radio-button>
      </el-radio-group>
      <the-search-input v-model="search" v-if="filter !== 'custom'" />
      <p v-if="search && list.length === 0 && filter !== 'custom'">
        {{ $t('agent-console.transfer-call.no-search-results', { search }) }}
      </p>
      <div v-if="filter === 'custom'">
        <el-form>
          <el-form-item :label="$t('agent-console.transfer-call.custom-number')">
            <el-input v-model="value" />
          </el-form-item>
        </el-form>
      </div>
      <div class=" list" v-else>
        <label type="radio" v-for="item in list" :label="item.id" :key="item.id">
          <input type="radio" :value="item.id" v-model="value" :key="item.id" />
          <i class="fas" :class="{
            'fa-headset': filter === 'agent',
            'fa-robot': filter === 'queue',
          }"></i>
          <div>
            <div>{{ item.name }}</div>
            <div class="item__extra-info">
              <p>{{ $t('agent-console.transfer-call.number', { number: item.id }) }}</p>
            </div>
          </div>
        </label>
      </div>
      <div>
        <el-button type="primary" :disabled="!value" @click="handleAssistedTransfer">
          {{ $t('agent-console.transfer-call.assisted-transfer') }}
        </el-button>
        <el-button type="primary" :disabled="!value" @click="handleBlindTransfer">
          {{ $t('agent-console.transfer-call.blind-transfer') }}
        </el-button>
      </div>
    </div>
    <div v-else class="transfer-call__transferring">
      <div v-if="inCallWithAttended" class="transfer-call__in-call-with-attended">
        <p>
        {{ $t("agent-console.transfer-call.you-are-on-call-with", { name: selectedValue.name }) }}
        </p>
        <p>{{ numpadValue }}</p>
        <div class="dtmf-buttons">
          <the-button v-for="(button,i) in buttons" :key="i" :value="button.value" :text="button.text" :class="{ 'active' : button.active }" @click.native="handleButtonClick(button)"></the-button>  
        </div>
        <div>
          <el-button @click="handleGoBackToCall" v-if="transferType === 'assisted'">{{ $t("agent-console.transfer.go-back-to-call")}}</el-button>
          <el-button @click="hangupAndTransfer"  type="primary">
          {{ $t("agent-console.transfer.to-transfer") }}
          </el-button>
        </div>
      </div>
      <div v-else class="transfer-call__in-call-with-attended">
        <p>
          <i class="fas fa-circle-notch fa-spin"></i>
          {{ $t("agent-console.transfer-call.transferring-call-to", { name: selectedValue.name }) }}
        </p>
        <el-button @click="handleGoBackToCall" v-if="transferType === 'assisted'">{{ $t('common.cancel') }}</el-button>
      </div>
    </div>
  </div>
  <div v-else >
    <div class="transfer-call__transferring">
      <img src="@/img/success.svg" v-if="successTransfer" />
      <img src="@/img/error.svg" v-if="errorTransfer" />
      <p style="width: 80%;" class="text-center">{{ successTransfer ? $t('agent-console.transfer-call.call-transferred-successfully', {
        name: selectedValue.name
      }) : $t('agent-console.transfer-call.the-call-cannot-be-transferred-because-it-has-ended')}} </p>
      <el-button @click="handleGoBack">{{ $t('common.close') }}</el-button>
    </div>
  </div>
</template>

<script>
const AudioContext = window.AudioContext || window.webkitAudioContext || window.mozAudioContext;
import TheSearchInput from '@/components/html/TheSearchInput.vue'
import TheButton from "@/components/softphone/TheButton"
import Tone from "@/plugins/tone";
export default {
  props: {
    janus: {
      required: true,
    },
  },
  data () {
    return {
      search: "",
      filter: 'agent',
      value: 0,
      transferringCall: false,
      errorTransfer: null,
      successTransfer: null,
      inCallWithAttended: false,
      dtmf: new Tone(new AudioContext(), 350, 440),
      buttons: [
        { value: "1", active: false, f1: 697, f2: 1209 },
        { value: "2", text: 'abc', active: false, f1: 697, f2: 1336 },
        { value: "3", text: 'def', active: false, f1: 697, f2: 1477 },
        { value: "4", text: 'ghi', active: false, f1: 770, f2: 1209 },
        { value: "5", text: 'jkl', active: false, f1: 770, f2: 1336 },
        { value: "6", text: 'mno', active: false, f1: 770, f2: 1477 },
        { value: "7", text: 'pqrs', active: false, f1: 852, f2: 1209 },
        { value: "8", text: 'tuv', active: false, f1: 852, f2: 1336 },
        { value: "9", text: 'vwxyz', active: false, f1: 852, f2: 1477 },
        { value: "*", text: '', active: false, f1: 941, f2: 1209 },
        { value: "0", text: '+', active: false, f1: 941, f2: 1336 },
        { value: "#", text: '', active: false, f1: 941, f2: 1477 }
      ],
      transferType: null,
      numpadValue: '',
      goBackByUser: false
    }
  },
  components: {
    TheSearchInput,
    TheButton
  },
  computed: {
    agent () {
      return this.$store.getters['getAgent']
    },
    list () {
      return this.filter === 'agent' ? this.agents : this.queues
    },
    queues () {
      return this.$store.getters['getQueuesDashboardList']
        .filter(queue => !queue.isQueueAgent)
        .filter((queue) => {
          if (!this.search) {
            return queue
          }

          return queue.name.toLowerCase().includes(this.search.toLowerCase()) || queue.queue.toString().includes(this.search.toLowerCase())
        }).map((queue) => ({
          id: queue.queue,
          name: queue.name,
          extra: {
            agentsOnline: queue.onlineAgents,
          }
        }))
    },
    agents () {
      return this.$store.getters['getAgentsDashboard']
        .filter(agent => agent.call_logged && agent.have_call_center)
        .filter((agent) => {

          if (!this.search) {
            return agent
          }

          return agent.name.toLowerCase().includes(this.search.toLowerCase()) || agent.number.toString().includes(this.search.toLowerCase())
        }).map((agent) => ({
          id: agent.number,
          name: agent.name,
          extra: {
            inCall: agent?.call_status === 'call',
            inBreak: agent.in_break ?? false
          }
        }))
    },
    selectedValue () {
      return this.filter === 'custom' ? { id: this.value, name: this.value } : this.list.find(item => item.id === this.value)
    },
    cleanValue () {
      return typeof this.value === 'string' ? this.value.replace(/[A-Za-z$#%&/()=?¡¿!'\\|°"^[\]{}~;,.:\-_*+¬ `]/g, '') : this.value
    },
    call () {
      return this.$store.getters['getActiveItem']
    },
    isCallActive () {
      return this.call.active
    }
  },
  methods: {
    async handleAssistedTransfer () {
      this.transferType = 'assisted'
      this.transferringCall = true
      this.janus.sendDtmf(`*02${this.cleanValue}`)
      const snapshot = await this.$store.dispatch('doAssistedTransfer', this.cleanValue)

      this.$store.dispatch('listenToAction', { path: "call_center", actionId: snapshot.key, callback: (data) => {
        if (!data || !this.transferringCall) {
          return
        }

        if (data.inCallWithAttended) {
          this.inCallWithAttended = true
        }

        if (data.status) {
          this.successTransfer = data.status === 'success'
          this.errorTransfer = !this.successTransfer
        }

      }})

    },
    handleBlindTransfer () {
      this.transferType = 'blind'
      this.transferringCall = true
      this.janus.sendDtmf(`##${this.cleanValue}`).then(() => {
        this.successTransfer = true
        this.errorTransfer = false
        this.$store.dispatch('setCallTransfered')
      })
    },
    handleGoBackToCall() {
      this.janus.sendDtmf('**')
      this.transferringCall = false
      this.successTransfer = null
      this.errorTransfer = null
      this.inCallWithAttended = false
    },
    hangupAndTransfer() {
      this.janus.hangup()
      this.successTransfer = true
      this.errorTransfer = false
    },
    handleGoBack() {
      this.$emit('callTransferred')
      this.resetComponent()
    },
    resetComponent() {
      this.search =  ""
      this.filter =  'agent'
      this.value =  0
      this.transferringCall =  false
      this.errorTransfer =  null
      this.successTransfer =  null
      this.inCallWithAttended =  false
      this.transferType = null
      this.numpadValue = ''
    },
    handleButtonClick(button) {
      this.numpadValue += button.value
      this.playTone(button)
    },
    playTone(button) {
      this.janus.sendDtmf(button.value)
      
      this.dtmf.freq1 = button.f1
      this.dtmf.freq2 = button.f2

      if (this.dtmf.status == 1) {
       this.dtmf.stop()
      }

      if (this.dtmf.status == 0) {
        this.dtmf.start()
      }

      setTimeout(() => {
        this.dtmf.stop()
      }, 250)
    },
    handlePress(evt) {
      const value = evt.key
      const button = this.buttons.find(button => button.value == value)

      if (button){
        this.playTone(button)
        button.active = true
        this.buttons = this.buttons.map(btn => btn.value === value ? button : btn)
        setTimeout(() => {
          button.active = false
          this.buttons = this.buttons.map(btn => btn.value === value ? button : btn)
        }, 250)
      }
    }
  },
  watch: {
    filter () {
      if (this.filter !== 'custom') {
        this.value = 0
      } else {
        this.value = ''
      }
    },
    transferringCall(value) {
      if (value) {
        this.$emit('denyClose')
      } else {
        this.$emit('allowClose')
      }
    },
    successTransfer(value) {
      if (value) {
        setTimeout(() => {
          this.handleGoBack()
          this.goBackByUser = false
        }, 8000)
      }
    }
  },
  created () {
    this.$store.dispatch('listenQueuesDashboardArray', [this.agent.organization_id]);
  }
}
</script>
<style scoped>
header > div {
  display: flex;
  flex-direction: row;
  justify-content:space-between;
  align-items:center;
}

.transfer-call__content {
  display: flex;
  flex-direction: column;
  gap: var(--column);
  height: 100vh;
  padding: var(--column);
}

.transfer-call__transferring {
  display: flex;
  flex-direction: column;
  gap: var(--column);
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.transfer-call__in-call-with-attended {
  display: flex;
  flex-direction: column;
  gap: var(--column);
  justify-content: center;
  align-items: center
}

.list {
  display: flex;
  flex-direction: column;
  gap: calc(var(--column) / 2);
  overflow-y: auto;
  flex: 1
}

.list label {
  display: flex;
  align-items: center;
  gap: calc(var(--column) / 2);
  border-radius: var(--border-radius);
  padding: var(--column);
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}

label .item__extra-info {
  font-size: 12px
}

img {
  width: 5em;
  margin: var(--column) auto;
  display: block;
}

.dtmf-buttons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--column);
  grid-auto-rows: minmax(10px, auto);
}

.text-center {
  text-align: center;
}
</style>